module.exports = __webpack_public_path__ + "static/media/HAUX_ENFERMAGEM_1.7dcefa1f.pdf";